import React from 'react';
import { connect } from 'dva';
import styles from './index.module.scss';

function Footer({ goYS, goZC }) {
  const goToYS = () => {
    goZC();
  };
  const goToWT = () => {
    goYS();
  };
  return (
    <div className={styles['footer_fdfsd']}>
      <div className={styles['content_fdf']}>
        {/* <div className={styles['a']}>
          <ul>
            <li className={styles.msg_text_box}>
              <div className={styles.msg_text}>手机版下载</div>
              <img
                onClick={() =>
                  window.open(
                    'https://apps.apple.com/cn/app/atv-%E4%BA%9E%E6%B4%B2%E9%9B%BB%E8%A6%96/id1262995639'
                  )
                }
                src={require('./image/apple_app.png').default}
              />
              <img
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.zn.android'
                  )
                }
                src={require('./image/google_app.png').default}
              />
            </li>
            <li className={styles.msg_text_box_s}>
              <div className={styles.msg_text_s}>
                如安卓流动设备没有Google Play
              </div>
              <img
                onClick={() =>
                  window.open('https://eo-pub.yinxianwl.com/atv-app-apk/HKATV.apk')
                }
                src={require('./image/an.png').default}
              />
            </li>
          </ul>
        </div> */}
        {/* <div className={styles['a']}>
          <ul>
            <li className={styles.msg_text_box}>
              <div className={styles.msg_text}>TV版下载</div>
              <img
                onClick={() =>
                  window.open(
                    'https://play.google.com/store/apps/details?id=com.asiatv.box'
                  )
                }
                src={require('./image/google_app.png').default}
              />
            </li>
            <li className={styles.msg_text_box_s}>
              <div className={styles.msg_text_s}>
                如TV设备没有Google Play，请直接下载，U盘安装
              </div>
              <img
                onClick={() =>
                  window.open('https://eo-pub.yinxianwl.com/stb-app/ATVBox.apk')
                }
                src={require('./image/tv.png').default}
              />
            </li>
          </ul>
        </div> */}
        <div className={styles.two_func}>
          <div className={styles.fjdsiof}>
            <p style={{ textAlign: 'center', opacity: '0.8' }}>
              <span>电邮： developer@yinxianwl.com</span>
              {/* <span>抖音电邮： douyin_cs@hkatv.com</span> */}
              {/* <span>
                专人接听服务时间：
                星期一至五，上午9时至下午6时，星期六、日及公众假期休息
              </span> */}
            </p>
            <p className={styles.fdsjifo23} style={{ textAlign: 'center' }}>
              <span onClick={() => goToYS()} style={{ cursor: 'pointer' }}>
                隐私政策 |
              </span>
              {/* <span onClick={() => goToWT()} style={{ cursor: 'pointer' }}>
                服务条款 |
              </span> */}
              <span>常见问题</span>
              <span className={styles.msg_text}>
                © 版权所有2025 成都音线网络科技有限公司
              </span>
              {/* <img
                onClick={() =>
                  window.open('https://www.facebook.com/atvhongkong/')
                }
                src={require('./image/facebook.png').default}
              />
              <img
                onClick={() => window.open('https://www.instagram.com/hk_atv/')}
                src={require('./image/instagram.png').default}
              />
              <img
                onClick={() =>
                  window.open('https://www.youtube.com/c/atvhongkong')
                }
                src={require('./image/play.png').default}
              /> */}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
export default connect(null, (dispatch) => ({
  goYS() {
    dispatch({
      type: 'modelState/setExplain',
      payload: {
        state: true,
        data: {
          contentName: 'clause',
        },
      },
    });
  },
  goZC() {
    dispatch({
      type: 'modelState/setExplain',
      payload: {
        state: true,
        data: {
          contentName: 'policy',
        },
      },
    });
  },
}))(Footer);
